import { Skeleton } from '~/src/common/components/Skeleton/Skeleton';
import { useScreenSize } from '~/src/common/hooks/useScreenSize';
import {
  IMAGE_SIZE_SMALL,
  IMAGE_SIZE_LARGE,
} from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/components/ImageSlider/layout';

import * as S from './layout';

export const ProductScreenSkeleton = () => {
  const size = useScreenSize();

  const imageSize = size.isSmallScreen ? IMAGE_SIZE_SMALL : IMAGE_SIZE_LARGE;

  return (
    <S.Root role="progressbar">
      <Skeleton width="60%" height={16} />

      <S.Content>
        <S.Grid>
          <S.Caroussel>
            <S.Thumbnail height={80} width={80} />
            <Skeleton height={imageSize} width={imageSize} />
            <Skeleton height={imageSize} width={imageSize} />
          </S.Caroussel>

          <S.PrimaryInformation>
            <Skeleton width={300} height={24} />
            <Skeleton width={150} height={16} />
          </S.PrimaryInformation>

          <S.SecondaryInformation>
            <Skeleton height={64} width={64} />
            <Skeleton height={64} width={64} />
          </S.SecondaryInformation>

          <S.Picker>
            <Skeleton width={80} height={24} />
            <Skeleton height={42} width={135} />
          </S.Picker>

          <S.ShortDescription>
            <Skeleton />
            <Skeleton width={100} />
          </S.ShortDescription>
        </S.Grid>

        <S.ProductInformation>
          <Skeleton width={90} />
          <Skeleton height={60} />
        </S.ProductInformation>

        <S.AdditionalInformation>
          <Skeleton width={150} />
          <Skeleton height={600} />
        </S.AdditionalInformation>
      </S.Content>
    </S.Root>
  );
};
